import vuex from "vuex";
import imovel from "./imoveis/imovel";
import auth from "./auth/auth";
import admin from "./admin/admin";
import reports from "./reports/reports";
import carousel from "./carousel/carousel";
import auditlog from "./auditlog/auditlog";
import ticket from "./support/ticket";

export default new vuex.Store({
  modules: {
    imovel,
    auth,
    admin,
    reports,
    carousel,
    auditlog,
    ticket,
  },
});
